import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { TranslationService } from 'src/app/shared/services/translation.service';
import { ValidatorsService } from 'src/app/shared/services/validators.service';

export interface IForgotPasswordForm {
  email: string;
}

@Component({
    selector: 'auth-forgot-password-form',
    templateUrl: './forgot-password-form.component.html',
    styleUrls: ['./forgot-password-form.component.scss'],
    standalone: false
})
export class ForgotPasswordFormComponent implements OnInit {
  form: FormGroup;
  formErrors: Map<string, string> = new Map<string, string>();

  patternReference: any = {};

  @Output()
  onSubmit: EventEmitter<IForgotPasswordForm> = new EventEmitter<IForgotPasswordForm>();

  get emailPlaceHolder(): string {
    return this.translationService.translate('Auth.Email');
  }

  get passwordPlaceHolder(): string {
    return this.translationService.translate('Auth.Password');
  }

  constructor(
    private fb: FormBuilder,
    //private translate: TranslateService,
    public validators: ValidatorsService,
    private translationService: TranslationService) { }

  ngOnInit() {
    /*
    this.form = this.fb.group({
      'email': ['', this.validators.formBuilderValidationInitializer(true, null, true)]
    });
    */
    this.form = this.fb.group({
      email: this.fb.control('', {
        validators: this.validators.formBuilderValidationInitializer(true, null, true),
        updateOn: 'change'
      })
    });

    /*
    this.form["patternReference"] = {
      email: 1
    };
    */
    this.patternReference = {
      email: 1
    };

    //this.validators.trackInputChange(this.form);
    this.validators.trackInputChange(this.form, this.patternReference);
  }

  submit() {
    //sanitizing
    this.form.setValue(this.validators.multiSanitizerInput(this.form.value));

    if (!this.form.valid)
            return;

    this.formErrors.clear();

    this.onSubmit.emit({
      email: this.form.get("email").value
    });
  }
}
